











import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import { ICategoryMenuItem } from '@/contracts/Settings'

export default defineComponent({
  name: 'CategoryMenuListItem',
  props: {
    item: {
      type: Object as PropType<ICategoryMenuItem>,
      default: () => ({}),
    },
  },
  setup(props) {
    const component = computed(() => {
      return { type: 'a', props: { href: props.item.url } }
    })
    return {
      component,
    }
  },
})
